module.exports = __webpack_public_path__ + "static/media/coin-glow.70dbeaae.png";